var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"container",style:(_vm.configStyle),attrs:{"id":"container"}},[_c('ContainImage',{attrs:{"imageSrc":_vm.bannerAddFriend}}),_c('a',{attrs:{"href":_vm.basePath +
      '/' +
      _vm.redirectCode +
      '/' +
      _vm.serialCode +
      '?' +
      _vm.campaignIdParam +
      '=' +
      _vm.campaignId +
      '&blocked=true'}},[_c('ContainImage',{attrs:{"imageSrc":_vm.addFriendButton,"padding":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }